__turbopack_context__.v({
  "btn": "InputField-module-scss-module__PO63AW__btn",
  "btn-alt": "InputField-module-scss-module__PO63AW__btn-alt",
  "btn-default": "InputField-module-scss-module__PO63AW__btn-default",
  "btn-default-dark-bg": "InputField-module-scss-module__PO63AW__btn-default-dark-bg",
  "btn-disabled": "InputField-module-scss-module__PO63AW__btn-disabled",
  "btn-elite": "InputField-module-scss-module__PO63AW__btn-elite",
  "btn-gold": "InputField-module-scss-module__PO63AW__btn-gold",
  "btn-lg": "InputField-module-scss-module__PO63AW__btn-lg",
  "btn-link": "InputField-module-scss-module__PO63AW__btn-link",
  "btn-plat": "InputField-module-scss-module__PO63AW__btn-plat",
  "btn-primary": "InputField-module-scss-module__PO63AW__btn-primary",
  "btn-sm": "InputField-module-scss-module__PO63AW__btn-sm",
  "btn-success": "InputField-module-scss-module__PO63AW__btn-success",
  "btn-warning": "InputField-module-scss-module__PO63AW__btn-warning",
  "disabled": "InputField-module-scss-module__PO63AW__disabled",
  "elegant": "InputField-module-scss-module__PO63AW__elegant",
  "empty": "InputField-module-scss-module__PO63AW__empty",
  "invalid": "InputField-module-scss-module__PO63AW__invalid",
  "newWrapper": "InputField-module-scss-module__PO63AW__newWrapper",
  "password": "InputField-module-scss-module__PO63AW__password",
  "validation": "InputField-module-scss-module__PO63AW__validation",
});
